<form #f="ngForm" [formGroup]="register">
  <div label-extension>
    {{label}} <span class="required-field" *ngIf="required"></span>
  </div>
  <ng-container *ngIf="!isReadonlyValue">
    <div class="form-control-container">
      <div class='input-group'>
        <ngx-intl-tel-input [inputId]="'adsasd'"
                            [ngClass]="{'cell': custom=='NotWide', 'homephone':custom=='Wide','Wide':custom=='TooWide', 'Search':custom=='Search', 'required': (required == true && (this.register.controls?.phone.value == null || this.register.controls?.phone.value == '')) }"
                            [preferredCountries]="setpreferred"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                            [selectFirstCountry]="false"
                            [maxLength]="15"
                            (input)="onPhoneChanged($event)"
                            (focusin)="changeFormat(f.form.value?.phone?.e164Number)"
                            (focusout)="sendChanges()"
                            (keydown.enter)="sendChanges()"
                            (countryChange)="onCountryChange($event)"                         
                            [selectedCountryISO]="GetSelectedCountry"
                            [phoneValidation]="true"
                            [separateDialCode]="separateDialCode"
                            formControlName="phone">
        </ngx-intl-tel-input>
        <span style="color:red" class="set-value-message"
        [ngClass]="{'required': (required == true && (this.register.controls?.phone.value == null || this.register.controls?.phone.value == '')), 'not-required': required == false }"></span>
        <span *ngIf="Isvisible" style="color:red">{{ValidationText}}</span>
      </div>
    </div>
  </ng-container><br />
  <ng-container *ngIf="isReadonlyValue">
    <div class='input-group' style="margin-top: -15px;">
      <ngx-intl-tel-input [inputId]="'disable'"
                          [ngClass]="{'cell': custom=='NotWide', 'homephone':custom=='Wide','Wide':custom=='TooWide', 'Search':custom=='Search'}"
                          [enablePlaceholder]="false"
                          [enableAutoCountrySelect]="true"
                          [selectedCountryISO]="GetSelectedCountry"
                          [separateDialCode]="separateDialCode"
                          formControlName="phoned">
      </ngx-intl-tel-input>
    </div><br />
  </ng-container>
</form>
